// Use like set on sagas
const add = (obj, key) => ({ ...obj, [key]: true })

const remove = (obj, key) => {
  const x = { ...obj }
  delete x[key]
  return x
}

const toggle = (obj, key) => (obj[key] ? remove(obj, key) : add(obj, key))

const ObjectSet = { add, remove, toggle }

export default ObjectSet
